import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import RegistrationForm from "./components/RegistrationForm";
import RegistrationLayout from "./components/RegistrationLayout";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import MembersPage from "./pages/MembersPage";
import MemberDetailPage from "./pages/MemberDetailPage";
import ExpirationPage from "./pages/ExpirationPage";
import CatalogPage from "./pages/CatalogPage";
import ImportPage from "./pages/ImportPage";
import ReportsPage from "./pages/ReportsPage";
import SettingsPage from "./pages/SettingsPage";
import CashbookPage from "./pages/CashbookPage";
import CashEntryPage from "./pages/CashEntryPage";
import PrestationsPage from "./pages/PrestationsPage";
import PrestationsDashboardPage from "./pages/PrestationsDashboardPage";
import MutuellePage from "./pages/MutuellePage";
import CRMLayout from "./components/CRMLayout";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="crm-page-loading">Chargement...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const CRMRoute = ({ children }) => {
  const { user, loading, hasCrmAccess } = useAuth();
  if (loading) return <div className="crm-page-loading">Chargement...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (!hasCrmAccess) return <Navigate to="/inscription" replace />;
  return children;
};

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/" element={user ? <Navigate to="/inscription" replace /> : <Navigate to="/login" replace />} />
      <Route path="/login" element={user ? <Navigate to="/inscription" replace /> : <LoginPage />} />
      {/* Inscription: standalone layout, any authenticated user */}
      <Route path="/inscription" element={<ProtectedRoute><RegistrationLayout><RegistrationForm /></RegistrationLayout></ProtectedRoute>} />
      {/* Cash Entry: standalone layout, any authenticated user (no CRM access required) */}
      <Route path="/cash-entry" element={<ProtectedRoute><RegistrationLayout><CashEntryPage /></RegistrationLayout></ProtectedRoute>} />
      {/* Prestations: standalone layout for coaches, any authenticated user */}
      <Route path="/prestations" element={<ProtectedRoute><RegistrationLayout><PrestationsPage /></RegistrationLayout></ProtectedRoute>} />
      {/* Mutuelle: standalone layout, any authenticated user (Coach, Admin, Responsable) */}
      <Route path="/mutuelle" element={<ProtectedRoute><RegistrationLayout><MutuellePage /></RegistrationLayout></ProtectedRoute>} />
      {/* CRM: only for users with crm_access */}
      <Route element={<CRMRoute><CRMLayout /></CRMRoute>}>
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/members" element={<MembersPage />} />
        <Route path="/members/:id" element={<MemberDetailPage />} />
        <Route path="/expirations" element={<ExpirationPage />} />
        <Route path="/catalog" element={<CatalogPage />} />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/import" element={<ImportPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/cashbook" element={<CashbookPage />} />
        <Route path="/prestations-dashboard" element={<PrestationsDashboardPage />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
